// src/components/Navbar.jsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTenantSettings } from '../contexts/TenantSettingsContext';
import { Icon } from './ui';

export default function Navbar({ onMenuClick }) {
  const location = useLocation();
  const { settings, loading } = useTenantSettings();

  console.log('Navbar Tenant settings = ', settings);

  const getPageTitle = () => {
    const titles = {
      '/dashboard': 'Tableau de Bord',
      '/clients': 'Clients',
      '/invoices': 'Facturation',
      '/tasks': 'Tâches',
      '/settings': 'Paramètres',
      '/users': 'Utilisateurs',
      '/payments': 'Paiements',
      '/recurring-tasks': 'Tâches récurrentes',
    };
    return titles[location.pathname] || 'Tableau de Bord';
  };

  const companyName = loading
    ? '...'
    : settings?.name || settings?.companyName || 'Mon cabinet';

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="px-6 py-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-4">
            <button
              className="md:hidden p-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors"
              onClick={onMenuClick}
              aria-label="Ouvrir le menu"
            >
              <Icon name="IconMenu" className="text-gray-600" />
            </button>

            <div className="flex flex-col">
              <span className="text-xs text-gray-500 uppercase tracking-wide">
                {companyName}
              </span>
              <h2 className="text-xl font-semibold text-gray-800">
                {getPageTitle()}
              </h2>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <span className="text-sm text-gray-600">
              Admin System (admin)
            </span>
          </div>
        </div>
      </div>
    </header>
  );
}

Navbar.propTypes = {
  onMenuClick: PropTypes.func.isRequired,
};

Navbar.defaultProps = {
  onMenuClick: () => {},
};
